<template>
	<b-modal
		:size="screenWidth > 660 ? 'lg' : 'sm'"
		:visible="show"
		@hide="() => this.$emit('close')"
		hide-footer
	>
		<div>
			<div class="pl-5 text-center">
				<label>
					<input
						type="checkbox"
						class="form-check-input"
						@input="toggleDontShowAgain"
						v-model="dontShowAgain"
					/>
					{{ 'Do not show this instruction again' | translate }}
				</label>
			</div>
			<iframe
				:width="screenWidth > 660 ? 560 : 260"
				:height="screenWidth > 660 ? 315 : 145"
				:src="videoUrl"
				frameborder="0"
				allow="autoplay; encrypted-media"
				allowfullscreen
			/>
		</div>
	</b-modal>
</template>

<script>
export default {
	props: ['show'],
	name: 'modal-training-video',
	data: () => ({
		dontShowAgain: window.localStorage.getItem('dontShowTraining'),
		screenWidth: window.innerWidth,
	}),
	computed: {
		videoUrl() {
			const i18nLang = this.$store.state.i18n.locale
			if (i18nLang === 'ua') {
				return 'https://www.youtube.com/embed/-xaijvbYvaE'
			} else if (i18nLang === 'pl') {
				return 'https://www.youtube.com/embed/evsP-mhZSrk'
			} else {
				return 'https://www.youtube.com/embed/C4P9sK_IQks'
			}
		},
	},
	methods: {
		close() {
			this.$emit('close')
		},
		toggleDontShowAgain() {
			if (!this.dontShowAgain) {
				window.localStorage.setItem('dontShowTraining', 'true')
			} else {
				window.localStorage.removeItem('dontShowTraining')
			}
		},
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
iframe {
	display: block;
	margin: auto;
}

input {
	padding: 10px;
}
</style>
